import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {SlickCarouselComponent} from 'ngx-slick-carousel';

@Component({
  selector: 'app-challenge-summary',
  templateUrl: './challenge-summary.component.html',
  styleUrls: ['./challenge-summary.component.scss']
})
export class ChallengeSummaryComponent implements OnInit {
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;

  @Input()
  background: string;
  @Input()
  dotsColor: string;

  slideConfig = {
    slidesToShow: 2.5,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    infinite: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 998,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    let
      title = document.querySelector<HTMLElement>('.page__section'),
      slider = document.querySelector<HTMLElement>('.slick-track'),
      dots = document.querySelector<HTMLElement>('.slick-dots'),
      //pageSize = window.innerWidth
      spacing = title.offsetLeft

      //if(pageSize >= 1024) {
        slider.style.padding = `0 ${spacing}px`
        dots.style.paddingRight = spacing + 'px'
      //}
  }

}
